export const COOKIE_CONSENT_KEY = 'cm_cookie_consent';
